<template>
  <b-tab :title="$store.state.localization.data.mainPage.fuelTankCard.notificationTabLabel">
    <b-form-checkbox v-model="notificationsEnabled" switch>
      {{ $store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorEnabledLabel }}
    </b-form-checkbox>
  </b-tab>
</template>

<script>
import { userService } from "../../../services";

export default {
  name: "NotificationsTab",
  data() {
    return {
      notificationsEnabled: false
    };
  },
  created() {
    const notificationsEnabledSetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return x.settingName == userService.NOTIFICATIONS_ENABLED;
      });

      if (notificationsEnabledSetting && notificationsEnabledSetting.settingValue == "true") {
        this.notificationsEnabled = true;
      }
  },
  methods: {
    getEnabled() {
      return this.notificationsEnabled;
    },
  },
};
</script>
